import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'What is this SMS API service?',
      answer: 'Our SMS API allows developers to send SMS messages programmatically using a simple REST API. It is ideal for notifications, two-factor authentication, and other communication needs.'
    },
    {
      question: 'How do I get started with the API?',
      answer: 'To get started, sign in using your Google account, generate an API key from your dashboard, and refer to our documentation for examples on how to send your first SMS.'
    },
    {
      question: 'How much does it cost?',
      answer: (
        <>
          We offer several pricing tiers based on the number of messages you send each month. You can check out our <a href="/pricing" style={{ color: '#007BFF' }}>Pricing</a> page for detailed information on each plan.
        </>
      )
    },
    {
      question: 'Is there a free trial?',
      answer: 'Yes, we offer 3 free SMS messages to help you evaluate our service before committing to purchase credits.'
    },
    {
      question: 'Is there a Limit to the number of Daily SMS I can send?',
      answer: 'Yes, new users are given a limit of 100 SMS a day. If you think you will cross this limit let us know via email to smstextr@gmail.com and we will increase the limit for your account.'
    },
    {
      question: 'Can I send SMS worldwide?',
      answer: 'Yes! SMS Textr now supports sending SMS messages to multiple countries, including the USA, Canada, UK, Thailand, Portugal, India, Germany, Spain, Poland, Italy, Australia, Denmark, Ireland and Luxembourg, with plans to expand further in the future. Our service remains reliable and cost-effective, empowering you to connect globally.'
    },
    {
      question: 'Why are multiple credits deducted for a single SMS?',
      answer: (
        <>
        SMS messages may incur multiple credits based on two factors. <br/>Firstly, the region where you are sending the SMS might require more credits. For a list of all credits corresponding to regions, please visit our <a href="/regions" style={{ color: '#007BFF' }}>regions page</a>.<br/><br/>
        Secondly, SMS messages are billed based on the number of segments required to send the message. <br/><br/> 
        A "segment" is a portion of the message that fits within the character limits defined by SMS encoding standards:<br/><br/>
        1. <strong>GSM-7 Encoding</strong>:<br/>
        - Standard characters (e.g., alphabets, numbers, and some symbols) fall under this encoding.<br/>
        - Messages can have up to 160 characters per segment.<br/>
        - For messages exceeding this limit, the segments are reduced to 153 characters each due to concatenation data.<br/><br/>
        2. <strong>UCS-2 Encoding</strong>:<br/>
        - Non-standard characters (e.g., emojis, accented characters, or certain symbols) fall under UCS-2.<br/>
        - These messages are limited to 70 characters per segment.<br/>
        - For messages exceeding this limit, segments are reduced to 67 characters each due to concatenation data.<br/><br/>
        When your SMS exceeds these segment limits, it is split into multiple segments. Each segment deducts one credit from your account. This ensures the message is delivered seamlessly and reassembled properly on the recipient’s device.<br/><br/>
        It’s important to consider the type of characters used in your SMS and its length to manage the number of segments effectively.
            </>
        )
    },
    {
      question: 'How can I receive SMS from my clients or customers?',
      answer: 'You can receive SMS from numbers that you have already sent a SMS to via a Webhook Url. Once you log in to the dashboard, you can insert your own webhook url where you would like to receive the SMS. We will forward any SMS received from your clients to this Webhook Url.'
    },
    {
      question: 'Will credits be deducted to receive an SMS?',
      answer: 'Yes! We will deduct 1 credit per SMS recieved based on the GSM-7  and UCS-2 encoding standards of 160 characters and 70 characters respectively. You can leave the Webhook Url empty or leave it to the default value (https://default-webhook-url.com) to stop receiving SMS and thus your credits will not be deducted.'
    },
    {
      question: 'What is the OTP service?',
      answer: (
        <>
        The OTP or One-Time Password service allows you to send time-sensitive verification codes via SMS to your users. It is commonly used for login verification, account sign-up confirmation, and secure access. To learn more about the service visit the <a href="/otp" style={{ color: '#007BFF' }}>OTP Verification page</a>.
        </>
        )
    },
    {
      question: 'How do I contact support?',
      answer: 'You can reach out to our support team by emailing smstextr@gmail.com.'
    },
    {
      question: 'How is privacy handled?',
      answer: (
        <>
          You can visit our privacy policy page to read our <a href="/privacy" style={{ color: '#007BFF' }}>policy</a>.
        </>
      )
    }
  ];

  return (
    <div style={{ padding: '20px' }}>
      {/* SEO: Helmet for Title and Meta */}
      <Helmet>
        <title>FAQ | SMS Textr</title>
        <meta name="description" content="Find answers to frequently asked questions about SMS Textr, a simple SMS API service for sending SMS messages worldwide." />
        <meta name="keywords" content="SMS, API, FAQ, SMS Textr, messaging, developers, communication, SMS service" />
        <meta name="author" content="SMS Textr Team" />
      </Helmet>
      <h1 style={{ fontSize: '24px', color: 'Green' }}>Frequently Asked Questions (FAQ)</h1>
      <div style={timelineSectionStyle}>
        {faqs.map((faq, index) => (
          <div key={index} style={{ marginBottom: '30px', borderBottom: '1px solid #e0e0e0', paddingBottom: '20px' }}>
            <h2 
              style={{ fontSize: '20px', color: 'Green', cursor: 'pointer' }} 
              onClick={() => handleToggle(index)}
            >
              {faq.question}
            </h2>
            {openIndex === index && (
              <p style={{ fontSize: '16px', color: '#555' }}>{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const timelineSectionStyle = {
  backgroundColor: '#f9f9f9',
  padding: '30px',
  borderRadius: '8px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
};

export default FAQPage;
